import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { ConnectService } from '@service/connect.service';
import { ParamUrlService } from '@service/paramurl.service';
import { checkBoolean, clearStorage, returnEmpty } from '@core/_utils/tools.utils';
import { CommonService } from '@service/common.service';
import { EditorService } from '@service/editor.service';
import { AppComponent } from '../../app.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@service/language.service';
import { environment } from '../../../environments/environment';
import { LoadingService } from '@core/_services/loading.service';
import { AzureService } from '@service/azure.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers: [LanguageService],
})
export class LoginComponent implements OnInit {
    @Input() public identifiant = '';
    @Input() public password = '';
    public displayModal = false;
    public errMessage = '';

    public data: any;
    public error = false;
    private login$: any;
    public pBarValue: number = 0;
    public backGroundImage = '';
    public logo = '';
    private navPage: string;
    public selectedCountry: string;
    public countries: any[];
    public loadingMsg: string = '';
    public loginDisplay = false;
    public displayAzure = false;
    private ssoType = '';

    constructor(
        private router: Router,
        public menu: MenuServiceInt,
        public connectService: ConnectService,
        private activatedRoute: ActivatedRoute,
        private paramUrlService: ParamUrlService,
        private commonService: CommonService,
        private editorService: EditorService,
        public app: AppComponent,
        private translate: TranslateService,
        private loadingService: LoadingService,
        private azureService: AzureService,
    ) {
        this.menu.display = false;
        this.menu.userName = '';
        this.login$ = null;
        this.countries = [
            {name: 'FR', code: 'fr'},
            {name: 'EN', code: 'en'},
        ];
        this.selectedCountry = this.countries[0];
        this.app.languageIsLoaded = false;
        this.menu.menuRestrict = false;
        this.paramUrlService.restricted = false;
        this.displayAzure = environment.msalConfig.auth.clientId !== '' && environment.msalConfig.auth.authority !== '';
        this.ssoType = '';
    }

    ngOnInit() {
        this.navPage = '';
        let wUrlParam = '';
        this.login$ = this.activatedRoute.queryParams.subscribe((params) => {
            if (JSON.stringify(params) === '{}') {
                return;
            }
            // Ouverture de l'interface via la bannette
            wUrlParam = this.decryptParam(params['connect']);
            if (wUrlParam !== '') {
                this.connectAuto(wUrlParam, true);
                this.unSubs();
                return;
            }
            wUrlParam = returnEmpty(params['Content']);
            this.unSubs();
            if (wUrlParam !== '') {
                this.getContent(wUrlParam);
            } else {
                if (environment.cryptedUrl === false) {                           
                    this.navigatePage(params);            
                } else {
                    this.router.navigate(['/login']);  
                }
            }
            this.unSubs();
        });
        this.menu.userName = '';
        this.backGroundImage = this.connectService.getBackGroundImage();
        this.logo = this.connectService.getLogo();
        this.loadLanguage();
        this.azureService.initialize();
        this.azureService.onAuth.subscribe((data) => {
            this.execAzureLogin(data);
        });
    }

    ngOnDestroy() {
        this.azureService.destroy();
     }

    setLoginDisplay() {
        this.loginDisplay = this.azureService.loginDisplay;
    }

    public execAzureLogin(account) {
        this.ssoType = 'azure';
        this.connect(account.username, '', false, true);
    }

    private unSubs() {
        if (this.login$ !== null) {
            this.login$.unsubscribe();
        }
    }

    private loadLanguage() {        
        if (this.app.languageIsLoaded === false) {
            this.loadCurrentLanguage(this.app.currentLanguage);            
        }
    }
        
    private async loadCurrentLanguage(aCurrentLanguage) {
        let wRes: any;
        this.translate.setDefaultLang(aCurrentLanguage);
        wRes = await this.app.languageService.loadCurrentLanguage(aCurrentLanguage);
        this.app.languageIsLoaded = true;
        this.connectService.currentLanguage = aCurrentLanguage;
        this.menu.setLogoutMenu(this.translate.instant('DisConnect'));        
    }

    public async onChangeCountry(event) {
        this.app.currentLanguage = event.value.code;
        this.app.languageIsLoaded = false;
        await this.loadCurrentLanguage(event.value.code);
    }

    onSubmit(identifiant = this.identifiant, password = this.password) {
        this.verifyconnect(identifiant, password);
    }

    public clickLogin(identifiant = this.identifiant, password = this.password) {
        this.verifyconnect(identifiant, password);
    }

    private verifyconnect(identifiant, password) {
        if (this.identifiant.trim() !== '') {
            this.ssoType = '';
            this.connect(identifiant, password, false, true);
        }        
    }

    public clickAzure() {
        if (environment.msalConfig.auth.clientId !== '' && environment.msalConfig.auth.authority !== '') {
            this.ssoType = 'azure';
            this.azureService.execAuth();        
        }     
    }

    showDialog() {
        this.displayModal = true;
    }

    hideDialog() {
        this.displayModal = false;
        this.errMessage = '';
    }

    private getIdent(aParams) {
        let wIdent = '';
        let wDisp = true;
        wIdent = this.decryptParam(aParams['cnx']);
        if (aParams['displaymenu'] !== undefined) {
            wDisp = checkBoolean(aParams['displaymenu']);
        }
        if (wIdent !== '') {
            this.connectAuto(wIdent, wDisp);
        }
    }

    private async getContent(aContent) {
        let wRes: any;
        wRes = await this.paramUrlService.getContent(aContent);
        this.navigatePage(wRes);
    }

    private navigatePage(aParams) {
        let wUrlParam = '';
        wUrlParam = this.paramUrlService.getPageFromUrl(aParams['search'], 'login');
        if (wUrlParam !== '') {
            this.paramUrlService.getRestricted(aParams);
            this.navPage = wUrlParam;
            if (this.navPage === 'notfound') {
                this.router.navigate(['/' + this.navPage]);
            } else {
                this.paramUrlService.getRequestParams(wUrlParam, aParams);
                this.getIdent(aParams);
            }
        }
    }

    private decryptParam(aData) {
        let wRes: string;
        wRes = '';
        if (aData !== undefined) {
            wRes = atob(aData);
        }
        return wRes;
    }

    private connectAuto(aIdent, aDisp) {
        if (aIdent === '') {
            return;
        }
        let wIdentifiant: string = '';
        let wPass: string = '';
        let wParam = aIdent.split('=', 2);
        if (wParam[0]) {
            wIdentifiant = wParam[0];
        }
        if (wParam[1]) {
            wPass = wParam[1];
        }
        this.connect(wIdentifiant, wPass, true, aDisp);
    }

    private async connect(identifiant, password, aCrypted, aDisp) {
        let wRes: any;
        let wResReset: any;
        this.pBarValue = 0;
        this.menu.menuRestrict = this.paramUrlService.restricted;

        this.loadLanguage();
        // Vérification validité demande
        wRes = await this.connectService.execCheckConnect(identifiant);
        if (wRes === false) {    
            this.displayDialog(this.translate.instant('Login.Refused'));
        } else {
            wRes = await this.connectService.connect(identifiant, password, aCrypted, aDisp, this.ssoType, (callBack) => {
                this.pBarValue = callBack;
            });
            if (wRes.result === false) {
                clearStorage();
                this.loadingService.resetLoader();
                this.router.navigate(['login'], { queryParams: {} });
            } else {
                if (wRes.reset === true) {
                    this.displayDialog(wRes.errMessage);
                } else {
                    wResReset = await this.connectService.verifyResetPwd(identifiant);
                    this.editorService.setIsLoading(false);
                    this.verifyResetPwd(wResReset, wRes);
                }
            }
        }
    }

    private verifyResetPwd(aResReset, aRes) {
        this.pBarValue = 100;
        this.loadingService.resetLoader();

        // Gestion erreur à faire
        if (aResReset.status === true) {
            if (aResReset.data.data === true) {
                this.commonService.resetPass = true;
                this.router.navigate(['page-reset-pwd']);
            } else {
                this.commonService.resetPass = false;
                this.endConnect(aRes);
            }
        } else {
            this.displayDialog(aResReset.Message);
        }
    }

    private displayDialog(aMessage) {
        this.errMessage = aMessage;
        this.password = '';
        this.showDialog();
    }

    private endConnect(aRes) {
        if (aRes.result === true) {
            this.app.menuTheme = this.menu.menuTheme;
            this.app.topbarTheme = this.menu.topBarTheme;
            // Si accès sans passer par l'url, utilisation de la page de l'utilisateur
            if (this.navPage === '') {                
                this.router.navigate(['/' + this.verifyNavigate(aRes.page)]);
            } else {
                this.router.navigate(['/' + this.navPage]);
            }
        } else {
            this.errMessage = aRes.errMessage;
            // if (aRes.result === false) {
                clearStorage();
            // }
            if (aRes.reset === true) {
                this.password = '';
                this.showDialog();
            }            
        }
    }

    private verifyNavigate(aPage) {
        let wPage = aPage;
        var fn;
        const type = {
            'fulltextsearch': this.fullText,
            'page-tree-search': this.browse,
            'page-tree-api': this.browse,
            'page-request-list': this.index,
            'page-request-api': this.index,
            'page-basket-list': this.basket
        }
        if (type[aPage]) {
            fn = type[aPage](wPage, this.menu);
            return fn;
        } else {
            return wPage;
        }
    }

    private fullText(aPage, aMenu) {
        return aMenu.fullText(aPage);
    }

    private browse(aPage, aMenu) {
        return aMenu.browse(aPage);
    }

    private index(aPage, aMenu) {
        return aMenu.index(aPage);
    }

    private basket(aPage, aMenu) {
        return aMenu.basket(aPage);
    }
}
